import { Form, Formik, FormikProps } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { IMemberOverview, UserNameable } from '../../../../lib/types';
import { FormActionsRow } from '../../../_core/form/input/form-actions-row';

interface IEditMemberFormFieldProps {
  givenName: string;
  familyName: string;
}

interface IEditMemberFormProps extends IRIFormProps<UserNameable> {
  member: IMemberOverview;
}

export const EditMemberForm = ({ member, onBack, onSubmit }: IEditMemberFormProps) => {
  return (
    <Formik
      initialValues={{
        givenName: member.givenName ?? member.user.givenName ?? '',
        familyName: member.familyName ?? member.user.familyName ?? ''
      }}
      onSubmit={({ givenName, familyName }) => onSubmit({ givenName: givenName.trim(), familyName: familyName.trim() })}
    >
      {(props: FormikProps<IEditMemberFormFieldProps>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <FormInputWithLabel name="givenName" label="First Name" placeholder="Edit first name" />
          <FormInputWithLabel name="familyName" label="Last Name" placeholder="Edit last name" />
          <FormActionsRow>
            {!!onBack && <FormButton onPress={onBack} text="Cancel" type="button" variant="secondary" />}
            <FormButton loading={props.isSubmitting} text="Update" />
          </FormActionsRow>
        </Form>
      )}
    </Formik>
  );
};
